import template from './component.tpl.html';
import TicketTemplateMapSettingController from './controller';

angular.module('festzelt-os.modules.tickets.templates')
    .component('alTicketTemplateMapSetting', {
        bindings: {
            definitionInformation: '<',
            currentModel: '<',
            onModelUpdate: '&'
        },
        controller: TicketTemplateMapSettingController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/components/al-ticket-template-map-setting/component.js